import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { observer } from 'mobx-react-lite';
import { ApplicationSdk } from "../../../stores";
import { Dropdown } from 'primereact/dropdown';
import OrderDialogStore from "../../../stores/manager/dialog/OrderDialogStore";


const EditOrderDialog = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    const store = sdk.currentDialog || null;

    let objectList: any = sdk.objects?.all.filter(store.currentObjectFilter).map((obj: any) => ({
        label: obj.name,
        value: obj
    }));

    if (store.selectedObject) {
        if (!objectList.find((obj: any) => obj.value.id === store.selectedObject.id)) {
            objectList.push({
                label: store.selectedObject.name,
                value: store.selectedObject
            });
        }
    }

    return (
        <Dialog
            visible={!!store}
            header={store.header}
            onHide={() => {
                sdk.closeDialog();
                if(!store.isNewOrder) {
                    sdk.openDialog(OrderDialogStore, { order_id: store.order_id });
                }
            }}
            style={{ width: '40rem' }}
        >
            <div className="p-fluid">
                {/* Dropdown für Objekte */}
                <div className="field" style={{ marginBottom: '1rem' }}>
                    <label htmlFor="objectDropdown">Objekt auswählen</label>
                    <Dropdown
                        id="objectDropdown"
                        value={store.selectedObject}
                        options={objectList}
                        onChange={(e) => store.selectObject(e.value)}
                        placeholder="Objekt auswählen"
                        filter
                        onFilter={(e) => {
                            store.filterObject(e.filter)
                        }}
                        loading={sdk.objects?.loading || false}
                        style={{ width: '100%' }}
                    />
                </div>
                {/* Dropdown für Reiniger */}
                <div className="field" style={{ marginBottom: '1rem' }}>
                    <label htmlFor="cleanerDropdown">Reinigungskraft auswählen</label>
                    <Dropdown
                        id="cleanerDropdown"
                        value={store.selectedCleaner || 0}
                        options={[
                            { label: "Keine Reinigungskraft", value: 0 }, // Add this option for null
                            ...(sdk.cleaner?.all.filter(store.currentCleanerFilter).map((cleaner: any) => ({
                                label: cleaner.name,
                                value: cleaner.id
                            })) || [])
                        ]}
                        onChange={(e) => store.selectCleaner(e.value)}
                        placeholder="Reinigungskraft auswählen"
                        filter
                        onFilter={(e) => {
                            store.filterCleaner(e.filter)
                        }}
                        loading={sdk.cleaner?.loading || false}
                        style={{ width: '100%' }}
                    />
                </div>
                {/* Button zum Erstellen des Auftrags */}
                <div style={{ textAlign: 'right', marginTop: '2rem' }}>
                    <Button
                        label={store.buttonLabel}
                        icon="pi pi-check"
                        className="p-button-success"
                        disabled={!store.isValid}
                        onClick={() => {
                            store.createOrUpdateOrder().then(({ id, event }: { id: number | null, event: string | null }) => {
                                if (event) {
                                    sdk.closeDialog(event);
                                    sdk.openDialog(OrderDialogStore, { order_id: id });
                                }
                            });
                        }}
                    />
                </div>
            </div>
        </Dialog>
    );
});

export default EditOrderDialog;